<template>
    <Header
        :elements="countElements"
        :current="countElements"
    ></Header>
    <ThankYou></ThankYou>
</template>

<script>
import ThankYou from '@/components/blocks/ThankYou.vue'
import Header from '@/components/Header-Short-New.vue'
import http from "@/api/http";
import {to_top} from "@/helper";

export default {
    components: {
        Header,
        ThankYou
    },
    data() {
        return {
            classes: []
        }
    },
    mounted() {
        to_top()
        this.init()
    },
    methods: {
        async init() {
            let { data } = await http.get('trademark-revival/step-thank-you/' + this.$route.params.key);

            if (data.res) {
                this.classes = data.data.data.classes

                if (data.data.data.status != 'C' || data.data.data.status_payment != 'Y') {
                    this.$router.push({ path: '/trademark-revival/step-2/' + this.$route.params.key })
                }

                this.$store.commit('header/setTotal', data.data.data.total)
            }
        },
    },
    computed: {
        countElements() {
            return this.classes.length ? 5 + this.classes.length : 0
        }
    }
}
</script>
